import axios from 'axios';
import Cookies from 'js-cookie';
import { rootAPI } from '../../config/api';

export const FETCH_TICKETS_REQUEST = 'FETCH_TICKETS_REQUEST';
export const FETCH_TICKETS_SUCCESS = 'FETCH_TICKETS_SUCCESS';
export const FETCH_TICKETS_FAILED  = 'FETCH_TICKETS_FAILED';

export const fetchTicketsRequest = () => ({ type: FETCH_TICKETS_REQUEST });

export const fetchTicketsSuccess = (data) => ({
  type: FETCH_TICKETS_SUCCESS,
  payload: data,
});

export const fetchTicketsFailed = (error) => ({
  type: FETCH_TICKETS_FAILED,
  payload: error,
});

let ticketRequest = 0;
export const fetchTickets = (appId, params = {}) => {
  const token = Cookies.get('token');

  const cleanParams = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== '' && v !== null)
  );

  return async (dispatch) => {
    ticketRequest += 1;
    const request = ticketRequest;
    dispatch(fetchTicketsRequest());
    try {
      const response = await axios.get(`${rootAPI}/api/basic/v2.0.0/tickets/${appId}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        params: cleanParams,
      });
      if (request === ticketRequest) dispatch(fetchTicketsSuccess(response.data));
    } catch (error) {
      if (request !== ticketRequest) return;
      dispatch(
        fetchTicketsFailed(error?.response?.data?.message || 'Failed to load tickets.')
      );
    }
  };
};